import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // NEW

const firebaseConfig = {
  apiKey: "AIzaSyAopTalpFFu1TbgL1vHVxHEwKmktE4VTZU",
  authDomain: "housefed-conony.firebaseapp.com",
  projectId: "housefed-conony",
  storageBucket: "housefed-conony.firebasestorage.app",
  messagingSenderId: "344332174582",
  appId: "1:344332174582:web:4d16bf0576521a654c58d7",
  measurementId: "G-1VNM63J140"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// IMPORTANT: Connecting to your specific named database
const db = getFirestore(app, "housefed-colony-database");
const storage = getStorage(app); // NEW

export { auth, db, googleProvider, storage };